// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","White":"#FFFFFF","link":"G90494a"};